import AdminOnboardingChecklist from "./AdminOnboardingChecklist";

export default AdminOnboardingChecklist;